export default "__VITE_ASSET__CENrbZ6B__"